import { $t } from "../../../utils/intl";
import { handleTextField } from "../../prefill/helpers";
import type { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { defaultToReviewString } from "../review/reviewString.helpers";
import { TextFieldControl } from "../text/TextFieldControl/TextFieldControl";
import type { TextFieldValue } from "../text/text.config";

export const recordTitleFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "record-title",
  control: (props) => (
    <TextFieldControl placeholder={$t(fieldsText.titlePlaceholder)} type="text" {...props} />
  ),
  prefill: handleTextField,
  toReviewString: defaultToReviewString,
};
